import React from 'react';

type ButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
};

const Button: React.FC<ButtonProps> = ({
  onClick,
  disabled = false,
  children,
  style,
  className = '',
  type = 'button',
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`form-control text-center fw-600 border-0 p-0 ${className}`}
    style={{
      background: disabled
        ? 'linear-gradient(135deg, #9CA3AF 0%, #D1D5DB 100%)'
        : 'linear-gradient(135deg, #FF4B6E 0%, #FF9A56 100%)',
      color: '#FFFFFF',
      boxShadow: disabled
        ? '0 4px 15px rgba(156, 163, 175, 0.3)'
        : '0 4px 15px rgba(255, 75, 110, 0.3)',
      transition: 'all 0.2s ease-in-out',
      position: 'relative',
      overflow: 'hidden',
      opacity: disabled ? 0.6 : 1,
      ...style,
    }}
    onMouseEnter={e => {
      if (!disabled) {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 75, 110, 0.4)';
      }
    }}
    onMouseLeave={e => {
      if (!disabled) {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 15px rgba(255, 75, 110, 0.3)';
      }
    }}
  >
    {children}
  </button>
);

export default Button;